import { WindowState } from '../state';
import { MaterialFamily } from '../types';

const MATERIAL_OPTIONS: { value: MaterialFamily; label: string }[] = [
  { value: MaterialFamily.WOOD, label: 'Wood (Hout)' },
  { value: MaterialFamily.UPVC, label: 'uPVC (Kunststof)' },
  { value: MaterialFamily.ALUMINIUM, label: 'Aluminium' },
  { value: MaterialFamily.STEEL, label: 'Steel (Staal)' },
  { value: MaterialFamily.WOOD_ALU, label: 'Wood-Aluminium' },
];

export function createMaterialSelector(state: WindowState): HTMLElement {
  const container = document.createElement('div');

  // Material family
  const matRow = document.createElement('div');
  matRow.className = 'opt-row';

  const matLabel = document.createElement('span');
  matLabel.className = 'opt-label';
  matLabel.textContent = 'Material';

  const matSelect = document.createElement('select');
  matSelect.className = 'opt-select';

  for (const opt of MATERIAL_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (state.config.frame.material === opt.value) option.selected = true;
    matSelect.appendChild(option);
  }

  matSelect.addEventListener('change', () => {
    state.setFrameMaterial(matSelect.value as MaterialFamily);
  });

  matRow.appendChild(matLabel);
  matRow.appendChild(matSelect);
  container.appendChild(matRow);

  // Outside color
  const outsideRow = document.createElement('div');
  outsideRow.className = 'opt-row';

  const outsideLabel = document.createElement('span');
  outsideLabel.className = 'opt-label';
  outsideLabel.textContent = 'Outside';

  const outsideColor = document.createElement('input');
  outsideColor.type = 'color';
  outsideColor.className = 'opt-color';
  outsideColor.value = state.config.frame.outsideColor;

  outsideColor.addEventListener('input', () => {
    state.setFrameColor('outside', outsideColor.value);
  });

  outsideRow.appendChild(outsideLabel);
  outsideRow.appendChild(outsideColor);
  container.appendChild(outsideRow);

  // Inside color
  const insideRow = document.createElement('div');
  insideRow.className = 'opt-row';

  const insideLabel = document.createElement('span');
  insideLabel.className = 'opt-label';
  insideLabel.textContent = 'Inside';

  const insideColor = document.createElement('input');
  insideColor.type = 'color';
  insideColor.className = 'opt-color';
  insideColor.value = state.config.frame.insideColor;

  insideColor.addEventListener('input', () => {
    state.setFrameColor('inside', insideColor.value);
  });

  insideRow.appendChild(insideLabel);
  insideRow.appendChild(insideColor);
  container.appendChild(insideRow);

  return container;
}
